module.exports = __webpack_public_path__ + "img/XLS.03a56c8d.png";